module.exports = __webpack_public_path__ + "img/124.98e254de.jpg";